import React, { useState } from 'react';
import { Link, LinkProps } from 'react-router-dom';

interface CustomTooltipProps extends Omit<LinkProps, 'title'> {
    tooltipText?: string;
    children: React.ReactNode;
}

export const CustomTooltipLink: React.FC<CustomTooltipProps> = ({ tooltipText, children, ...props }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <div 
            style={{ position: 'relative', display: 'inline-block' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Link {...props}>
                {children}
            </Link>
            
            {isHovered && tooltipText && (
                <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    marginTop: '8px',
                    padding: '6px 10px',
                    backgroundColor: '#333',
                    color: '#fff',
                    borderRadius: '4px',
                    fontSize: '12px',
                    whiteSpace: 'nowrap',
                    zIndex: 1000,
                    pointerEvents: 'none',
                    fontFamily: '"Philosopher", sans-serif',
                    boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
                }}>
                    {tooltipText}
                    {/* Tooltip arrow */}
                    <div style={{
                        position: 'absolute',
                        bottom: '100%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        borderWidth: '5px',
                        borderStyle: 'solid',
                        borderColor: 'transparent transparent #333 transparent'
                    }} />
                </div>
            )}
        </div>
    );
};
